// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderMenu_wrapper__Yct5u","container":"HeaderMenu_container__gjgS9","link":"HeaderMenu_link__20NKf","error":"HeaderMenu_error__QrHTT"};